// Tenant industry → Fleet Dispatch vs Concrete. Non-concrete orgs (mulch, freight,
// other) run the lean "Fleet Dispatch" experience: same War Room / GPS / jobs /
// contractor portal, but no concrete production screens or mix/batch fields.
export const isFleet = (org) => !!org && (org.industry || "concrete") !== "concrete";

export const INDUSTRIES = [
  { value: "concrete", label: "Concrete" },
  { value: "mulch", label: "Mulch / Garden" },
  { value: "freight", label: "Freight" },
  { value: "other", label: "Other" },
];

export const industryLabel = (v) => (INDUSTRIES.find((i) => i.value === v)?.label) || "Concrete";

// Concrete-production pages hidden from Fleet Dispatch tenants (UI only).
export const CONCRETE_ONLY_PATHS = [
  "/batcher", "/mixes", "/live", "/slump-log", "/pour-warnings",
  "/inventory", "/surcharges", "/pricing", "/leads", "/pump-companies",
];

// Pages shown ONLY to Fleet Dispatch tenants (hidden from concrete plants).
export const FLEET_ONLY_PATHS = ["/materials"];

// Delivery units a Fleet Dispatch tenant can order in.
export const FLEET_UNITS = [
  { value: "m3", label: "m³" },
  { value: "tonnes", label: "Tonnes" },
  { value: "scoops", label: "Scoops" },
];
export const unitLabel = (v) => (FLEET_UNITS.find((u) => u.value === v)?.label) || "m³";

// Friendly Fleet wording over the shared status engine.
export const FLEET_STATUS_LABELS = {
  scheduled: "Pending",
  loading: "Dispatched",
  slumping: "Dispatched",
  en_route: "In Transit",
  on_site: "On Site",
  discharging: "Delivering",
  returning: "Returning",
  delivered: "Delivered",
  complete: "Delivered",
  cancelled: "Cancelled",
};
